import { useStyles } from './styles'

export type Time = {
  hours: number
  minutes: number
  seconds: number
}

type ProgressBarProps = {
  width: number
  color: `#${string}`
  borderRadius?: string
}

export const ProgressBar = (props: ProgressBarProps) => {
  const { classes } = useStyles()

  const areaWidth = props.width
  const br = props.borderRadius || '0'

  return (
    <div
      className={classes.fulfilledArea}
      style={{ width: `${areaWidth}%`, backgroundColor: props.color, borderRadius: br }}
    />
  )
}
